import Store from '../../../universal/common/persistence/Store';
import STORAGE_TYPES from '../../../universal/common/persistence/storageTypes';

const STORE_PREFIX = 'storefront.core';

const MEMBER_CONFIGS = {
  appVersion: {
    storageType: STORAGE_TYPES.LOCAL,
  },
  debugLogging: {
    storageType: STORAGE_TYPES.LOCAL,
  },
};

const coreStore = new Store(STORE_PREFIX, MEMBER_CONFIGS);

export default coreStore;
